import React from "react";
import Education from "./Education";
import Work from "./Work";

import "./styles/allEducationAndWork.css";

const AllEducationAndWork = ({ props, type }) => {
  return (
    <div className="education-work-container">
      {type === "education"
        ? props?.map((element, index) => (
            <Education
              key={index}
              institution={element?.institution}
              course={element?.course}
              duration={element?.duration}
              logo={element?.logo}
            />
          ))
        : props?.map((element, index) => (
            <Work
              key={index}
              company={element?.company}
              role={element?.role}
              duration={element?.duration}
              description={element?.description}
              logo={element?.logo}
            />
          ))}
    </div>
  );
};

export default AllEducationAndWork;
